"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorBoundary = _interopRequireDefault(require("./ErrorBoundary"));

var _Actor = _interopRequireDefault(require("./tracking/Actor"));

var _ScreenType = _interopRequireDefault(require("./tracking/ScreenType"));

var _Experiments = _interopRequireDefault(require("./tracking/Experiments"));

var _InAppWebView = _interopRequireDefault(require("./tracking/InAppWebView"));

var _UFTI = _interopRequireDefault(require("./tracking/UFTI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Connector = function Connector(_ref) {
  var enabledOptimizelyFeatures = _ref.enabledOptimizelyFeatures,
      enabledUnleashFeatures = _ref.enabledUnleashFeatures,
      screenType = _ref.screenType;
  return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement(_Actor["default"], null), /*#__PURE__*/_react["default"].createElement(_ScreenType["default"], {
    screenType: screenType
  }), /*#__PURE__*/_react["default"].createElement(_Experiments["default"], {
    enabledOptimizelyFeatures: enabledOptimizelyFeatures,
    enabledUnleashFeatures: enabledUnleashFeatures
  }), /*#__PURE__*/_react["default"].createElement(_InAppWebView["default"], null), /*#__PURE__*/_react["default"].createElement(_UFTI["default"], null));
};

Connector.propTypes = {
  enabledOptimizelyFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string),
  enabledUnleashFeatures: _propTypes["default"].arrayOf(_propTypes["default"].string),
  screenType: _propTypes["default"].string
};
var _default = Connector;
exports["default"] = _default;
//# sourceMappingURL=Connector.js.map